function setMaxCardTitleHeight() {
    let max = 0;

    document
        .querySelectorAll(".card-product .card-title-line-space")
        .forEach(el => {
            max = Math.max(max, el.getBoundingClientRect().height);
        });

    if (max) {
        document.documentElement.style.setProperty(
            "--card-title-height",
            `${Math.ceil(max)}px`
        );
    }
}

setMaxCardTitleHeight();
window.addEventListener("load", setMaxCardTitleHeight)
window.addEventListener("resize", () => {
    console.log("resizeing ::");

    setMaxCardTitleHeight();
})